import { styled } from '@mui/material';

export const DonutChartTooltipWrapper = styled('div')(({ theme }) => ({
  position: 'fixed',
  transform: 'translateX(-50%)',
  pointerEvents: 'none',
  backgroundColor: theme.palette.background.opposite,
  borderRadius: theme.shape.borderRadius,
  boxShadow: theme.shadows[3],
  padding: theme.spacing(1),
  zIndex: 1500,
  color: theme.palette.common.white,
  '&::after': {
    content: '""',
    position: 'absolute',
    top: '100%',
    left: '50%',
    transform: 'translateX(-50%)',
    width: 0,
    height: 0,
    borderLeft: '6px solid transparent',
    borderRight: '6px solid transparent',
    borderTop: `6px solid ${theme.palette.background.opposite}`,
  },
}));
